import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { CdsModule } from '@cds/angular';
import { ClarityModule } from '@clr/angular';

import {
  // loadChartIconSet,
  loadCommerceIconSet,
  loadCoreIconSet,
  loadEssentialIconSet,
  // loadMediaIconSet,
  // loadMiniIconSet,
  // loadSocialIconSet,
  loadTechnologyIconSet,
  // loadTextEditIconSet,
  // loadTravelIconSet,
} from '@cds/core/icon';
import '@cds/core/icon/register.js';
import { ClickPreventPropagationDirective } from './directives/click-prevent-propagation.directive';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { DropdownMultiSelectComponent } from './components/dropdown-multi-select/dropdown-multi-select.component';

function loadIconsSet() {
  loadCoreIconSet();
  loadEssentialIconSet();
  loadTechnologyIconSet();
  loadCommerceIconSet();
}

@NgModule({
  declarations: [SafeHtmlPipe, DropdownMultiSelectComponent, HasPermissionDirective],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CdsModule,
    ClarityModule,
    ClickPreventPropagationDirective,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SafeHtmlPipe,
    CdsModule,
    ClarityModule,
    DropdownMultiSelectComponent,
    HasPermissionDirective,
  ],
})
export class SharedModule {
  constructor() {
    loadIconsSet();
  }
}
